import React, {Component} from 'react'

const Terms = (props) => (
    <div id="terms-modal" style={{padding: '0 20px'}}>
        <div dangerouslySetInnerHTML={{__html: props.template}} />
    </div>
)
export default class TermsModal extends Component
{

    constructor(props) {
        super(props);

        let template = '';

        switch (props.userType) {
            default:
            case 'talent':
                template = laravel.platform_settings.Asset_Talent_Marketplace_Terms_of_Service;
                break;
            case 'client':
                template = laravel.platform_settings.Asset_Client_Marketplace_Terms_of_Service;
                break;
        }
        this.state = {
            template
        }
    }

    render()
    {
        return (
            <div className="modal-table p-2">

                <Terms template={this.state.template}/>

                <div className="flex px-3 mb-2 items-center justify-end">
                    {this.props.userType === 'talent' && (
                        <a href="/storage/platform-settings/sample-independent-contractor-agreement"
                           target="_blank"
                           className="btn-primary btn mx-2">
                            View Sample ICA
                        </a>
                    )}
                    <button type="button" onClick={() => this.props.onClose()} className="btn-outline-dark btn mx-2">
                        Close
                    </button>
                </div>
            </div>
        )
    }
}
